export default "__VITE_PUBLIC_ASSET__a2b5c7e4__"